import { ref, type Ref } from 'vue'

/**
 * Composable für native HTML5 Drag & Drop Logik.
 * Ermöglicht das Sortieren einer Liste von Elementen.
 * 
 * @param items Ref der Liste, die sortiert werden soll
 * @param onReorder Callback, der aufgerufen wird, wenn die Sortierung abgeschlossen ist
 */
export function useDragAndDrop<T extends { id?: string }>(
  items: Ref<T[]>,
  onReorder: (newItems: T[]) => void
) {
  const draggedItemIndex = ref<number | null>(null)
  const isDragging = ref(false)

  const handleDragStart = (index: number) => {
    draggedItemIndex.value = index
    isDragging.value = true
    
    // Optional: Globaler Body-Class für Cursor-Styling
    document.body.classList.add('is-dragging')
  }

  const handleDragOver = (event: DragEvent, index: number) => {
    event.preventDefault()
    
    // DropEffect anzeigen
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move'
    }

    if (draggedItemIndex.value === null || draggedItemIndex.value === index) return

    // Visuelles Reordering in der lokalen Ref
    const newItems = [...items.value]
    const [draggedItem] = newItems.splice(draggedItemIndex.value, 1)
    newItems.splice(index, 0, draggedItem)
    
    items.value = newItems
    draggedItemIndex.value = index
  }

  const handleDrop = () => {
    if (draggedItemIndex.value !== null) {
      onReorder([...items.value])
    }
    cleanup()
  }

  const handleDragEnd = () => {
    cleanup()
  }

  const cleanup = () => {
    draggedItemIndex.value = null
    isDragging.value = false
    document.body.classList.remove('is-dragging')
  }

  return {
    isDragging,
    draggedItemIndex,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd
  }
}












